import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MainLayout from './views/MainLayout'
import ManageUserAccounts from './views/ManageUserAccounts'
import AddAccount from "./views/AddAccount";
import EditAndDeleteAccount from "./views/EditAndDeleteAccount";
import AddDepartment from "./views/AddDepartment";
import EditAndDeleteDepartment from "./views/EditAndDeleteDepartment";
import Dashboard from "./views/Dashboard";
import Report from "./views/Report";
import DataMedicalEquipment from "./views/DataMedicalEquipment";
import AddDataTool from "./views/AddDataTool";
import EditAndDeleteTool from "./views/EditAndDeleteTool";
import Login from "./views/Login";
import EditProfileUser from "./views/EditProfileUser";
import ChangePasswordUser from "./views/ChangePasswordUser";


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    //Login
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // Main layout
    {
      path: '/',
      name: 'mainlayout',
      component: MainLayout,
      children: [
        {
          path: '/',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/manage-user-accounts',
          name: 'manageuseraccounts',
          component: ManageUserAccounts
        },
        {
          path: '/add-account',
          name: 'AddAccount',
          component: AddAccount
        },
        {
          path: '/edit-and-delete-account/:id',
          name: 'EditAndDeleteAccount',
          component: EditAndDeleteAccount
        },
        {
          path: '/add-department',
          name: 'AddDepartment',
          component: AddDepartment
        },
        {
          path: '/edit-and-delete-department/:id',
          name: 'EditAndDeleteDepartment',
          component: EditAndDeleteDepartment
        },
        {
          path: '/report',
          name: 'Report',
          component: Report
        },
        {
          path: '/data-medical-equipment',
          name: 'DataMedicalEquipment',
          component: DataMedicalEquipment
        },
        {
          path: '/add-data-tool',
          name: 'AddDataTool',
          component: AddDataTool
        },
        {
          path: '/edit-and-delete-tool/:id',
          name: 'EditAndDeleteTool',
          component: EditAndDeleteTool
        },
        {
          path: '/edit-user',
          name: 'EditProfileUser',
          component: EditProfileUser
        },
        {
          path: '/edit-password',
          name: 'ChangePasswordUser',
          component: ChangePasswordUser
        },
      ]
    }
  ]
})
